{
  "notification.wallet_topup_confirmed": {
    "title": "Nạp tiền thành công",
    "body": "Ví của bạn đã được nạp {{amount}} {{currency}}. Số dư hiện tại: {{balance_after}} {{currency}}."
  },
  "notification.invoice_generated": {
    "title": "Hóa đơn mới đã sẵn sàng",
    "body": "Hóa đơn {{invoice_number}} kỳ {{period_start}} – {{period_end}} với tổng {{total}} {{currency}} đã sẵn sàng để tải."
  },
  "notification.withdraw_approved": {
    "title": "Yêu cầu rút tiền đã được duyệt",
    "body": "Yêu cầu rút tiền {{request_id}} số tiền {{amount}} {{currency}} đã được duyệt và đang chờ chuyển khoản."
  },
  "notification.wallet_low_balance": {
    "title": "Số dư ví thấp",
    "body": "Số dư ví của bạn hiện là {{balance}} {{currency}}, dưới ngưỡng cảnh báo {{threshold}} {{currency}}. Vui lòng nạp thêm để duy trì đơn hàng."
  },
  "notification.wallet_low_balance_test": {
    "title": "Cảnh báo thử — số dư ví thấp",
    "body": "Đây là cảnh báo THỬ NGHIỆM. Số dư ví giả định là {{balance}} {{currency}} so với ngưỡng cảnh báo {{threshold}} {{currency}}. Không cần thao tác gì."
  },
  "notification.new_topup_request": {
    "title": "Yêu cầu nạp tiền mới",
    "body": "Merchant {{merchant_name}} đã gửi yêu cầu nạp {{request_id}} số tiền {{amount}} {{currency}} qua {{method}}."
  },
  "notification.new_withdraw_request": {
    "title": "Yêu cầu rút tiền mới",
    "body": "Merchant {{merchant_name}} đã gửi yêu cầu rút {{request_id}} số tiền {{amount}} {{currency}}."
  },
  "notification.pending_request_reminder": {
    "title": "Nhắc nhở yêu cầu đang chờ",
    "body": "Có {{count}} yêu cầu đang chờ xử lý quá {{hours}} giờ. Vui lòng kiểm tra."
  },
  "notification.merchant_credit_overdue": {
    "title": "Merchant nợ quá hạn",
    "body": "Merchant {{merchant_name}} có khoản nợ quá hạn {{amount}} {{currency}}, đã quá hạn {{days_overdue}} ngày."
  },
  "notification.imap_fail": {
    "title": "Lỗi đọc email IMAP",
    "body": "Bộ đọc IMAP ngân hàng {{account}} gặp lỗi: {{error}}. Lần đọc thành công cuối: {{last_success_at}}."
  },
  "notification.bullmq_dlq_alert": {
    "title": "Job chuyển sang hàng đợi lỗi",
    "body": "Queue {{queue}} chuyển job {{job_id}} sang hàng đợi lỗi (DLQ) sau {{attempts}} lần thử. Nguyên nhân: {{reason}}."
  },
  "notification.auto_recharge_fail": {
    "title": "Tự động nạp tiền thất bại",
    "body": "Tự động nạp cho merchant {{merchant_name}} số tiền {{amount}} {{currency}} thất bại: {{reason}}. Số dư ví: {{balance}} {{currency}}."
  },
  "notification.auto_pay_batch": {
    "title": "Đã xử lý lô tự động thanh toán",
    "body": "Lô tự động thanh toán {{batch_id}} đã xử lý {{success_count}}/{{total_count}} hóa đơn với tổng {{total}} {{currency}}. {{failed_count}} hóa đơn lỗi."
  },
  "notification.invoice_sent": {
    "title": "Hoá đơn mới đã phát hành",
    "body": "Hoá đơn {{invoice_number}} ({{amount}} {{currency}}) đã được phát hành. Vui lòng kiểm tra và thanh toán đúng hạn."
  },
  "notification.invoice_paid": {
    "title": "Hoá đơn đã được thanh toán",
    "body": "Hoá đơn {{invoice_number}} đã được thanh toán {{amount}} {{currency}}. Cảm ơn quý khách."
  },
  "notification.invoice_payment_submitted": {
    "title": "Có khoản thanh toán mới chờ duyệt",
    "body": "Merchant đã gửi khoản thanh toán {{amount}} {{currency}} cho hoá đơn {{invoice_number}} qua {{gateway}}. Vào hàng đợi kế toán để duyệt hoặc từ chối."
  },
  "notification.invoice_payment_rejected": {
    "title": "Khoản thanh toán đã bị từ chối",
    "body": "Khoản thanh toán {{amount}} {{currency}} cho hoá đơn {{invoice_number}} đã bị từ chối. Lý do: {{reason}}. Vui lòng kiểm tra và gửi lại bằng chứng thanh toán đúng."
  },
  "notification.credit_memo_issued": {
    "title": "Credit memo mới đã được phát hành",
    "body": "Bạn vừa nhận được credit memo trị giá {{amount}} USD. Số dư có thể dùng để bù trừ vào hoá đơn kế tiếp."
  },
  "notification.invoice_overdue": {
    "title": "Hoá đơn đã quá hạn {{days}} ngày",
    "body": "Hoá đơn {{invoice_number}} đã quá hạn {{days}} ngày (hạn cũ: {{due_date}}). Số dư còn lại: {{amount}} {{currency}}. Vui lòng thanh toán sớm để tránh ảnh hưởng đến việc tạo đơn mới."
  },
  "notification.invoice_overdue_final": {
    "title": "Hoá đơn đã quá hạn 7 ngày — cảnh báo cuối",
    "body": "Hoá đơn {{invoice_number}} đã quá hạn {{days}} ngày (hạn cũ: {{due_date}}). Số dư còn lại: {{amount}} {{currency}}. Vui lòng thanh toán sớm để tránh ảnh hưởng đến việc tạo đơn mới."
  },
  "notification.credit_expiry_7d": {
    "title": "Credit của bạn sắp hết hạn 7 ngày",
    "body": "Credit hiện tại sẽ hết hạn trong 7 ngày. Vui lòng thanh toán dư nợ trước hạn để tránh bị khóa thẻ tự động."
  },
  "notification.credit_expiry_1d": {
    "title": "Credit hết hạn vào ngày mai",
    "body": "Credit hiện tại sẽ hết hạn trong 24 giờ tới. Đây là nhắc nhở cuối cùng — vui lòng thanh toán dư nợ ngay hôm nay."
  },
  "notification.credit_remind_at_amount": {
    "title": "Bạn đã dùng tới ngưỡng credit đã cài đặt",
    "body": "Bạn đã sử dụng {{used}} trên hạn mức {{limit}}. Đã đạt ngưỡng nhắc {{threshold}} bạn cài đặt khi nhận credit."
  },
  "notification.credit_sweep_applied": {
    "title": "Credit sweep tự động",
    "body": "Đã trừ {{amount}} từ wallet để trả nợ credit tự động."
  },
  "notification.crm_attachment_infected": {
    "title": "Tệp đính kèm bị phát hiện chứa mã độc",
    "body": "Tệp \"{{filename}}\" đã được cách ly. Mã chữ ký: {{signature}}."
  },
  "notification.order_assigned": {
    "title": "Đơn mới được giao",
    "body": "Đơn {{order_code}} vừa được phân cho bạn — vào {{link}} để xử lý."
  },
  "notification.order_paid": {
    "title": "Đơn hàng đã thanh toán",
    "body": "Đơn {{order_code}} vừa được thanh toán."
  },
  "notification.order_shipped": {
    "title": "Đơn hàng đã giao cho vận chuyển",
    "body": "Đơn {{order_code}} đã được giao cho đơn vị vận chuyển."
  },
  "notification.order_delivered": {
    "title": "Đơn hàng đã giao",
    "body": "Đơn {{order_code}} đã đến tay khách."
  },
  "notification.order_cancelled": {
    "title": "Đơn hàng bị huỷ",
    "body": "Đơn {{order_code}} đã bị huỷ."
  },
  "notification.order_qc_failed": {
    "title": "QC từ chối",
    "body": "Vendor báo lỗi QC ở đơn {{order_code}}."
  },
  "notification.order_qc_passed": {
    "title": "QC qua",
    "body": "Đơn {{order_code}} đã qua QC."
  },
  "notification.order_unpaid_autocancelled": {
    "title": "Đơn hàng tự huỷ vì chưa thanh toán",
    "body": "Đơn hàng #{{order_id}} đã bị tự huỷ vì chưa thanh toán quá {{hours}} giờ. Số tiền giữ chỗ đã được hoàn về ví. Vui lòng tạo lại đơn nếu vẫn cần xử lý."
  },
  "notification.tracking_rts_detected": {
    "title": "Kiện hàng bị hoàn về người gửi",
    "body": "Đơn hàng #{{order_id}} đã bị hãng vận chuyển hoàn về người gửi (mã vận đơn {{tracking_number}}). {{item_count}} sản phẩm bị ảnh hưởng — vui lòng kiểm tra và xử lý."
  },
  "notification.order_waiting": {
    "title": "Đơn hàng chờ bạn duyệt",
    "body": "Đơn hàng {{orderNumber}} đang chờ bạn duyệt trước khi gửi đi sản xuất. Hãy kiểm tra và gửi khi bạn sẵn sàng."
  },
  "notification.order_auto_pushed": {
    "title": "Đơn hàng đã gửi sản xuất",
    "body": "Đơn hàng {{orderNumber}} đã được tự động gửi đi sản xuất."
  },
  "notification.order_admin_sent": {
    "title": "Đơn hàng đã được hỗ trợ gửi sản xuất",
    "body": "Đơn hàng {{orderNumber}} đã được đội ngũ hỗ trợ gửi đi sản xuất thay cho bạn."
  },
  "notification.product_published": {
    "title": "Sản phẩm mới đã đăng",
    "body": "Mẫu {{product_name}} đã xuất bản."
  },
  "notification.product_approved": {
    "title": "Sản phẩm đã được duyệt",
    "body": "Sản phẩm \"{{product_name}}\" đã được admin duyệt và chuyển sang trạng thái Live."
  },
  "notification.product_rejected": {
    "title": "Sản phẩm bị từ chối",
    "body": "Sản phẩm \"{{product_name}}\" bị admin từ chối. Lý do: {{reason}}"
  },
  "notification.product_sync_failed": {
    "title": "Sync sản phẩm thất bại",
    "body": "Sản phẩm {{product_name}} không sync được sang {{store}}."
  },
  "notification.product_archived": {
    "title": "Sản phẩm đã lưu trữ",
    "body": "Mẫu {{product_name}} đã chuyển sang trạng thái lưu trữ."
  },
  "notification.store_connected": {
    "title": "Kết nối cửa hàng thành công",
    "body": "{{store}} store {{store_name}} đã kết nối."
  },
  "notification.store_disconnected": {
    "title": "Cửa hàng bị ngắt kết nối",
    "body": "{{store}} store {{store_name}} cần xác thực lại."
  },
  "notification.store_sync_started": {
    "title": "Bắt đầu đồng bộ",
    "body": "Đang sync {{count}} sản phẩm sang {{store}}."
  },
  "notification.store_sync_completed": {
    "title": "Hoàn tất đồng bộ",
    "body": "Đồng bộ {{store}} đã xong — {{count}} sản phẩm."
  },
  "notification.wallet_charged": {
    "title": "Trừ ví thanh toán đơn",
    "body": "Đơn {{order_code}} trừ ví {{amount}}."
  },
  "notification.wallet_payout_sent": {
    "title": "Đã gửi tiền cho payout",
    "body": "Payout {{payout_code}} thành công {{amount}}."
  },
  "notification.payout_available": {
    "title": "Thu nhập sẵn sàng rút",
    "body": "Bạn có {{amount}} sẵn sàng rút trong ví — vào {{link}}."
  },
  "notification.auto_pay_retry_exhausted": {
    "title": "Auto-pay retry tạm dừng",
    "body": "Hệ thống đã thử thanh toán tự động nhiều lần nhưng chưa thành công. Đơn hàng vẫn ở trạng thái pending_payment. Vui lòng nạp thêm tiền hoặc thanh toán thủ công."
  },
  "notification.auto_recharge_disabled": {
    "title": "Auto-recharge tạm dừng",
    "body": "Hệ thống đã thử nạp tiền tự động 3 lần (1 giờ / 6 giờ / 24 giờ) nhưng không thành công. Auto-recharge đã tự động tắt — vui lòng kiểm tra phương thức thanh toán đã liên kết và bật lại thủ công."
  },
  "notification.invoice_due": {
    "title": "Invoice sắp đến hạn",
    "body": "Invoice {{invoice_number}} hết hạn trong {{days}} ngày."
  },
  "notification.refund_issued": {
    "title": "Hoàn tiền invoice",
    "body": "Refund {{amount}} cho invoice {{invoice_number}} đã xử lý."
  },
  "notification.system_maintenance": {
    "title": "Lịch bảo trì hệ thống",
    "body": "Bảo trì lúc {{time}} — downtime dự kiến {{duration}}."
  },
  "notification.system_release": {
    "title": "Phiên bản mới đã phát hành",
    "body": "{{product}} {{version}} vừa lên — xem changelog."
  },
  "notification.security_alert": {
    "title": "Cảnh báo bảo mật",
    "body": "Phát hiện đăng nhập mới từ thiết bị lạ."
  },
  "notification.kyc_update": {
    "title": "Hồ sơ KYC cần cập nhật",
    "body": "Giấy tờ tuỳ thân của bạn sắp hết hạn trong {{days}} ngày."
  },
  "notification.support_ticket_assigned": {
    "title": "Ticket hỗ trợ mới được giao",
    "body": "Ticket {{ticketNumber}} ({{category}}) vừa được phân cho bạn — mở để phản hồi."
  },
  "notification.support_ticket_force_reassigned": {
    "title": "Ticket hỗ trợ được phân lại",
    "body": "Ticket {{ticketNumber}} ({{category}}) đã được chuyển về hàng đợi chưa gán và cần người phụ trách mới."
  },
  "notification.support_ticket_resolved": {
    "title": "Ticket hỗ trợ của bạn đã được xử lý",
    "body": "Ticket {{ticketNumber}} — {{subject}} đã được xử lý xong. Vào mục Hỗ trợ để xem lại hoặc mở lại."
  },
  "notification.support_ticket_opened_by_admin": {
    "title": "Support đã mở một ticket cho bạn",
    "body": "Ticket {{ticketNumber}} — {{subject}}. Vào mục Hỗ trợ để theo dõi."
  },
  "notification.support_ticket_reply": {
    "title": "Phản hồi hỗ trợ mới: {{subject}}",
    "body": "{{preview}}"
  },
  "notification.support_ticket_reply_no_subject": {
    "title": "Phản hồi hỗ trợ mới",
    "body": "{{preview}}"
  },
  "notification.support_ticket_created_for_desk": {
    "title": "Ticket mới #{{ticketNumber}}: {{subject}}",
    "body": "{{merchantName}} vừa mở ticket thuộc nhóm {{category}}. {{preview}}"
  },
  "notification.support_ticket_merchant_reply": {
    "title": "Người bán vừa trả lời #{{ticketNumber}}: {{subject}}",
    "body": "{{merchantName}}: {{preview}}"
  },
  "notification.member_landed_no_team": {
    "title": "Thành viên mới tham gia nhưng chưa có nhóm",
    "body": "{{member_name}} đã chấp nhận lời mời, nhưng nhóm được mời đã bị vô hiệu hoá — thành viên hiện chưa thuộc nhóm nào. Vui lòng gán lại nhóm cho họ."
  },
  "notification.uat_sample": {
    "title": "[UAT] Thông báo mẫu #{{n}} ({{category}})",
    "body": "Fixture UAT sweep — thông báo {{category}} số {{n}} để test danh sách/phân trang/badge chưa đọc."
  },
  "support.channel.down": {
    "title": "Kênh hỗ trợ ngừng hoạt động",
    "body": "Kênh {{platform}} \"{{name}}\" đã ngắt kết nối và không thể nhận tin nhắn. Hãy kết nối lại trong phần Cấu hình hỗ trợ."
  },
  "support.bridge.offline": {
    "title": "Thiết bị bridge ngoại tuyến",
    "body": "Bridge {{platform}} \"{{name}}\" đã ngoại tuyến ({{reason}}) và không thể gửi/nhận tin nhắn. Hãy đăng nhập lại bridge để khôi phục."
  },
  "support.channel.zalo_refresh_failed": {
    "title": "Làm mới token Zalo thất bại",
    "body": "Tự động làm mới token cho kênh Zalo \"{{name}}\" thất bại sau {{attempts}} lần thử: {{reason}}. Hãy kết nối lại kênh để khôi phục việc gửi tin."
  },
  "support.ticket.reopened_by_merchant": {
    "title": "Merchant đã mở lại một ticket",
    "body": "Merchant đã mở lại ticket {{ticketNumber}}."
  },
  "support.ticket.closed_by_merchant": {
    "title": "Merchant đã xác nhận đóng ticket",
    "body": "Merchant xác nhận đóng ticket {{ticketNumber}}."
  },
  "support.dispatch.created": {
    "title": "Yêu cầu xử lý mới",
    "body": "Bạn có một yêu cầu xử lý (dispatch) mới cần tiếp nhận."
  },
  "support.dispatch.handler_reply": {
    "title": "Bộ phận phản hồi dispatch",
    "body": "Bên xử lý vừa gửi tin trong dispatch của ticket {{ticketNumber}}."
  },
  "support.dispatch.returned": {
    "title": "Dispatch đã trả về",
    "body": "Bên xử lý đã trả kết quả cho ticket {{ticketNumber}}, cần bạn chốt với merchant."
  },
  "support.dispatch.vendor_reply": {
    "title": "Vendor phản hồi dispatch",
    "body": "Vendor vừa gửi tin trong dispatch của ticket {{ticketNumber}}."
  },
  "notification.support_ticket_rated": {
    "title": "Ticket được đánh giá {{rating}}/5",
    "body": "Ticket {{ticketNumber}} ({{category}}) nhận đánh giá {{rating}}/5 từ merchant."
  },
  "notification.support_ticket_rated_low": {
    "title": "Cảnh báo đánh giá thấp: {{rating}}/5",
    "body": "Ticket {{ticketNumber}} ({{category}}) nhận đánh giá thấp ({{rating}}/5) — xem lại hội thoại và xử lý tiếp."
  },
  "notification.support_ticket_resolved_rate": {
    "title": "Ticket của bạn đã được xử lý",
    "body": "Ticket {{ticketNumber}} ({{category}}) đã được xử lý xong — hãy đánh giá chất lượng hỗ trợ bạn nhận được."
  },
  "notification.order_waiting_sla_reminder": {
    "title": "Đơn đang chờ bạn duyệt",
    "body": "Đơn {{order_code}} đã chờ bạn duyệt {{minutes}} phút. Vui lòng kiểm tra và gửi vào sản xuất."
  },
  "vendor_allocation.proposal.created": {
    "title": "Đề xuất thay đổi phân bổ mới",
    "body": "{{proposer}} đã đề xuất thay đổi phân bổ vendor đang chờ duyệt. Lý do: {{reason}}"
  },
  "vendor_allocation.proposal.approved": {
    "title": "Đề xuất phân bổ đã được duyệt",
    "body": "Đề xuất thay đổi phân bổ vendor của bạn đã được {{approver}} duyệt và áp dụng vào blueprint."
  },
  "vendor_allocation.proposal.rejected": {
    "title": "Đề xuất phân bổ bị từ chối",
    "body": "Đề xuất thay đổi phân bổ vendor của bạn đã bị {{approver}} từ chối. Lý do: {{reason}}"
  },
  "notification.emb_fee_awaiting_accept": {
    "title": "Phí thêu chờ duyệt",
    "body": "Đơn {{orderNumber}} có phí thêu {{embFee}} chờ bạn duyệt. Hạn phản hồi: {{deadline}}."
  },
  "notification.emb_order_autocancelled_refund": {
    "title": "Đơn tự huỷ & hoàn tiền",
    "body": "Đơn {{orderNumber}} đã tự huỷ do quá hạn duyệt phí thêu. Đã hoàn {{refundAmount}} vào ví."
  },
  "notification.pricing_profile_changed": {
    "title": "Pricing profile đã thay đổi",
    "body": "Tài khoản của bạn được chuyển từ {{fromProfile}} sang {{toProfile}}. Tag chỉ mang tính thông tin, không đổi công thức giá."
  },
  "notification.admin_surcharge_debited": {
    "title": "Phụ phí điều chỉnh đã trừ từ ví",
    "body": "Đơn {{orderNumber}}: đã trừ {{amount}} — lý do: {{reason}}."
  },
  "notification.order_confirmed_charged": {
    "title": "Đơn hàng đã được xác nhận",
    "body": "Đơn {{orderNumber}} đã được xác nhận và trừ {{amount}} từ số dư của bạn (đã bao gồm thuế và vận chuyển)."
  },
  "notification.order_created": {
    "title": "Đơn hàng đã được tạo",
    "body": "Đơn hàng {{order_code}} đã được tạo."
  },
  "notification.order_charge_failed": {
    "title": "Tính phí đơn hàng thất bại",
    "body": "Việc tính phí đơn hàng {{order_code}} thất bại. Vui lòng kiểm tra phương thức thanh toán và thử lại."
  },
  "notification.order_in_production": {
    "title": "Đơn hàng đang sản xuất",
    "body": "Đơn hàng {{order_code}} hiện đang được sản xuất."
  },
  "notification.refund_failed": {
    "title": "Hoàn tiền thất bại",
    "body": "Không thể xử lý hoàn tiền cho đơn hàng {{order_code}}. Đội ngũ của chúng tôi đang kiểm tra."
  },
  "notification.dispute_opened": {
    "title": "Đã mở khiếu nại",
    "body": "Một khiếu nại đã được mở cho đơn hàng {{order_code}}. Vui lòng xem xét và phản hồi."
  },
  "notification.dispute_evidence_required": {
    "title": "Cần bổ sung bằng chứng khiếu nại",
    "body": "Cần cung cấp bằng chứng cho khiếu nại của đơn hàng {{order_code}} trước {{deadline}}."
  },
  "notification.dispute_resolved_refund": {
    "title": "Khiếu nại đã giải quyết — hoàn tiền",
    "body": "Khiếu nại của đơn hàng {{order_code}} đã được giải quyết bằng hoàn tiền."
  },
  "notification.dispute_resolved_resend": {
    "title": "Khiếu nại đã giải quyết — gửi lại hàng",
    "body": "Khiếu nại của đơn hàng {{order_code}} đã được giải quyết bằng cách gửi lại hàng thay thế."
  },
  "notification.dispute_resolved_rejected": {
    "title": "Khiếu nại đã giải quyết — từ chối",
    "body": "Khiếu nại của đơn hàng {{order_code}} đã được xem xét và bị từ chối."
  },
  "notification.label_purchased": {
    "title": "Đã mua nhãn vận chuyển",
    "body": "Đã mua nhãn vận chuyển cho đơn hàng {{order_code}} (mã theo dõi {{tracking_number}})."
  },
  "notification.label_void_failed": {
    "title": "Hủy nhãn vận chuyển thất bại",
    "body": "Việc hủy nhãn vận chuyển cho đơn hàng {{order_code}} thất bại."
  },
  "notification.label_rebuy_required": {
    "title": "Cần mua lại nhãn vận chuyển",
    "body": "Nhãn vận chuyển cho đơn hàng {{order_code}} cần được mua lại."
  },
  "notification.label_tracking_stalled": {
    "title": "Theo dõi vận chuyển bị ngưng cập nhật",
    "body": "Thông tin theo dõi cho đơn hàng {{order_code}} ({{tracking_number}}) đã lâu không được cập nhật."
  },
  "notification.embroidery_step2_reminder_24h": {
    "title": "Nhắc phí thêu",
    "body": "Đơn hàng {{orderNumber}} vẫn còn phí thêu đang chờ bạn phê duyệt — sẽ hết hạn trong 24 giờ."
  },
  "notification.address_change_requested": {
    "title": "Yêu cầu đổi địa chỉ",
    "body": "Có yêu cầu đổi địa chỉ giao hàng cho đơn hàng {{order_code}}."
  },
  "notification.address_change_confirmed": {
    "title": "Đã xác nhận đổi địa chỉ",
    "body": "Địa chỉ giao hàng của đơn hàng {{order_code}} đã được cập nhật."
  },
  "notification.address_change_expired": {
    "title": "Yêu cầu đổi địa chỉ đã hết hạn",
    "body": "Thời gian đổi địa chỉ cho đơn hàng {{order_code}} đã hết hạn mà chưa được xác nhận."
  },
  "notification.vendor_rating_dropped": {
    "title": "Điểm đánh giá nhà cung cấp giảm",
    "body": "Điểm đánh giá hiệu suất của nhà cung cấp {{vendor_name}} đã giảm xuống dưới ngưỡng."
  },
  "notification.vendor_assignment_revoked": {
    "title": "Đã thu hồi phân công",
    "body": "Phân công cho đơn hàng {{order_code}} đã bị thu hồi."
  },
  "notification.vendor_quality_warning": {
    "title": "Cảnh báo chất lượng",
    "body": "Đã phát cảnh báo chất lượng cho nhà cung cấp {{vendor_name}}."
  },
  "notification.webhook_delivery_exhausted_financial": {
    "title": "Gửi webhook thất bại",
    "body": "Một webhook tài chính đến {{endpoint}} đã hết số lần thử lại và không được gửi thành công."
  },
  "notification.webhook_subscription_disabled": {
    "title": "Đăng ký webhook đã bị tắt",
    "body": "Đăng ký webhook {{endpoint}} đã bị tắt sau nhiều lần gửi thất bại."
  },
  "notification.artwork_ingest_error": {
    "title": "Kiểm tra thiết kế thất bại",
    "body": "Đơn hàng {{order_id}} gặp lỗi thiết kế ở vùng {{area}} ({{error_code}}). Vui lòng kiểm tra và tải lên lại."
  },
  "notification.affiliate_payout_completed": {
    "title": "Cập nhật thanh toán affiliate",
    "body": "Có cập nhật cho khoản thanh toán affiliate {{payout_id}} của bạn."
  },
  "notification.vendor_reassignment_needed": {
    "title": "Cần xử lý gán vendor",
    "body": "Đơn {{order_code}} không tự gán được vendor ({{reason}}) — cần gán lại thủ công."
  },
  "notification.account_suspended": {
    "title": "Tài khoản bị tạm ngưng",
    "body": "Tài khoản của bạn đã bị tạm ngưng. Lý do: {{reason}}. Liên hệ hỗ trợ nếu bạn cho rằng đây là nhầm lẫn."
  },
  "notification.account_reactivated": {
    "title": "Tài khoản được kích hoạt lại",
    "body": "Tài khoản của bạn đã được kích hoạt lại. Bạn có thể đăng nhập và hoạt động bình thường."
  },
  "notification.blueprint_updated": {
    "title": "Blueprint đã cập nhật",
    "body": "Một blueprint bạn đang dùng vừa được cập nhật. Vui lòng kiểm tra và đăng lại sản phẩm bị ảnh hưởng nếu cần."
  },
  "notification.deal_expiry_warning": {
    "title": "Deal sắp hết hạn",
    "body": "Deal \"{{deal_name}}\" sẽ hết hạn sau {{days}} ngày."
  },
  "notification.embroidery_stitch_count_failed": {
    "title": "Đếm mũi thêu thất bại",
    "body": "Đơn {{order_id}}, sản phẩm {{item_id}}: dịch vụ đếm mũi thêu thất bại sau khi thử lại hết số lần. Cần xử lý thủ công."
  },
  "notification.invoice_generation_failed": {
    "title": "Tạo hóa đơn thất bại",
    "body": "Không thể tạo hóa đơn cho kỳ bắt đầu {{period_start}}. Đội ngũ của chúng tôi đã được thông báo và sẽ thử lại."
  },
  "notification.routing_pool_empty_merchant_rule": {
    "title": "Luật định tuyến của merchant làm cạn pool vendor",
    "body": "Một luật định tuyến của {{merchantName}} khiến {{variantLabel}} ({{blueprintName}}) không còn vendor nào hợp lệ. {{orderCount}} đơn đang chờ vì việc này. Hãy kiểm tra lại luật định tuyến của merchant đó để giải phóng chúng."
  },
  "notification.vendor_webhook_delivery_failed": {
    "title": "Gửi webhook thất bại",
    "body": "Không gửi được sự kiện {{eventType}} tới {{endpoint}} của {{vendorName}} sau {{attempts}} lần thử. Đơn vẫn thuộc vendor — hệ thống không chuyển cho ai khác. Không có replay từng sự kiện: hãy gọi GET /assignments và GET /events để lấy bù dữ liệu."
  },
  "notification.vendor_webhook_auto_disabled": {
    "title": "Endpoint webhook đã bị tự động tắt",
    "body": "Endpoint webhook {{endpoint}} của {{vendorName}} đã bị tắt tự động sau {{failureCount}} sự kiện liên tiếp gửi hỏng hết số lần thử. Hệ thống ngừng gửi sự kiện. Hãy chạy lại bước xác minh (handshake) ở trang Integration để bật lại, rồi gọi GET /assignments và GET /events để lấy bù dữ liệu."
  },
  "notification.vendor_integration_key_revoked": {
    "title": "API key đã bị thu hồi",
    "body": "API key {{keyPrefix}} của {{vendorName}} đã bị thu hồi. Mọi request còn dùng key này sẽ trả về 401. Hãy tạo key mới ở trang Integration nếu vẫn cần tích hợp."
  },
  "notification.vendor_integration_disabled_by_admin": {
    "title": "Admin đã tắt tích hợp API",
    "body": "{{actor}} đã tắt tích hợp API của {{vendorName}}. Toàn bộ API key của vendor này trả về 401 và không sự kiện webhook nào được gửi cho tới khi admin bật lại."
  },
  "_vgBindingP18": {
    "title": "vg-binding: P18.D-04 / vg-binding: P18.D-13 / vg-binding: P18.D-36",
    "body": "vg-binding: CONTEXT:decisions=P18.D-04,P18.D-13,P18.D-36 — phase 18 task-06 vendor Integration API notification rows (webhook delivery failed / endpoint auto-disabled / API key revoked / integration disabled by admin), added to en+vi+fr together because assertCatalogComplete() fails the build on a missing locale and tests run I18N_NOTIF_GUARD=strict (a fanout without an i18n_key throws). Not a notification key: absent from NOTIFICATION_KEYS, so lookup() never resolves it."
  },
  "_vgBinding": {
    "title": "vg-binding: CONTEXT:decisions=P17.D-04,P17.D-31,P17.D-43,P17.D-44",
    "body": "vg-binding: INTERFACE-STANDARDS:error-shape — phase 17 task-47 pool-empty admin notification catalog entry, added to en/vi/fr together (assertCatalogComplete fails the build on a missing locale). Not a notification key: absent from NOTIFICATION_KEYS, so lookup() never resolves it."
  }
}
